import React from "react";

import { makeStyles, Theme } from "@material-ui/core/styles";
import alertCircle from "../../../assets/svgs/alert-circle.svg";
import alertTriangle from "../../../assets/svgs/alert-triangle.svg";
import { incidentSettings, overLoadedSettings } from "./calloutRequestedData";

interface CalloutRequestedTopIconProps {
  isItIncident: boolean;
}

const useStyles = makeStyles<Theme, boolean>((theme) => ({
  icon: {
    padding: 17,
    marginRight: 10,
    justifySelf: "flex-start",
    background: (props) => (props ? incidentSettings.color : overLoadedSettings.color),
    borderRadius: 15,
    width: 84,
    height: 84,

    "@media (max-width: 1024px)": {
      width: 65,
      height: 65,
    },
  },
}));

const CalloutRequestedTopIcon: React.FC<CalloutRequestedTopIconProps> = ({ isItIncident }) => {
  const classes = useStyles(isItIncident);
  return <img src={isItIncident ? alertTriangle : alertCircle} className={classes.icon} />;
};

export default CalloutRequestedTopIcon;
